import { RelevantIDEntry } from './RelevantIDsProvider'
import useRegisterRelevantID from './useRegisterRelevantID'

/**
 * Declarative wrapper around {@link useRegisterRelevantID} for registering a
 * relevant ID from JSX (e.g. once per field in a `.map`), where calling the
 * hook directly isn't possible. Renders nothing.
 */
export default function RegisterRelevantID(entry: RelevantIDEntry) {
  useRegisterRelevantID(entry)
  return null
}
